import { Header } from './Header';
import { Hero } from './Hero';
import { MoleculeVideo } from './MoleculeVideo';
import { useMoleculePlayback } from './useMoleculePlayback';

export const HeroExperience = () => {
  const playback = useMoleculePlayback();
  return <div className="hero-experience" ref={playback.stageRef} data-testid="hero-experience">
    <MoleculeVideo playback={playback} />
    <Header overlay />
    <div className="hero-nav-spacer" aria-hidden="true" />
    <Hero playback={playback} />
  </div>;
};